import _ from 'lodash';
import { useAuthStore } from './store';
import { useGlobalMessageStore } from '@/plugins/clientModels/store';
export { useAuthStore };
import { PasswordUpdatePendingError } from './errors';
import { GlobalMessage } from '../clientModels';

export default {
	//i18n,
	install(app, options) {
		if (!options || !options.router) {
			throw new Error('Please initialize plugin with the router (options.router).');
		}

		const { router } = options;

		const alwaysAllowedRoutes = ['/login', '/updatePassword'];

		const redirectToLogin = (from, to, next) => {
			console.log('redirecting to login', 'to', to, 'from', from);
			return next({ path: '/login', query: { returnUrl: to.path } });
		};
		const redirectToPasswordUpdate = (from, to, next) => {
			console.log('redirecting to /updatePassword');
			return next({ path: '/updatePassword', query: { returnUrl: to.path } });
		};

		router.beforeEach(async (to, from, next) => {
			console.log('running navigation guard', '\nto\n', to, '\nfrom\n', from);
			try {
				if (alwaysAllowedRoutes.includes(to.path)) {
					return next();
				}

				const store = useAuthStore();
				const login = await store.getLogin();
				if (!login) return redirectToLogin(from, to, next);

				// login with username "admin" will bypass anything
				if (_.get(login, 'general.username') === 'admin') return next();

				const rolesHavingAccess = _.get(to, 'meta.roles');
				// the route requires the login to have at least one of "rolesHavingAccess" in "login.frontendRoles"
				if (rolesHavingAccess) {
					// if the intersection has more than 1 role,, at least one role from login.frontendRoles is contained in rolesHavingAccess
					const matchingRoles = _.intersection(rolesHavingAccess, login.effectiveFrontendRoles);
					if (matchingRoles.length) return next();
				}

				if (from.path === '/login') to.path = '/';

				const permissionDeniedInformation = new GlobalMessage({
					severity: 'information',
					title: 'Permission denied',
					message: 'You have not been granted access rights to this module.',
					icon: 'mdi-close-thick',
				});
				const globalMessageStore = useGlobalMessageStore();
				globalMessageStore.addMessage(permissionDeniedInformation);
			} catch (error) {
				// if there is some error while fetching the "login" object, just let the user login again and hope this fixes the issue
				if (error instanceof PasswordUpdatePendingError) return redirectToPasswordUpdate(from, to, next);
				else return redirectToLogin(from, to, next);
			}
		});
	},
};
